import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL, CURRENCY, PRICE_VALUE } from '../data/offer';
import { trackPixelEvent } from '../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  full?: boolean;
  location?: string;
}
export function CtaButton({
  children,
  size = 'md',
  full = false,
  location = 'page'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-5 text-base sm:text-lg tracking-tight' : 'px-6 py-4 text-sm sm:text-base';
  const handleClick = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: 'Dominio del Pickleball: El Manual Táctico',
      content_ids: ['dominio-pickleball-pack'],
      content_type: 'product',
      value: PRICE_VALUE,
      currency: CURRENCY,
      source_section: location
    });
  };
  return <a href={CHECKOUT_URL} onClick={handleClick} className={`group inline-flex items-center justify-center gap-3 rounded-xl bg-lime-400 font-display font-extrabold uppercase text-navy-950 shadow-card transition-[transform,background-color] duration-150 ease-smooth hover:bg-lime-500 active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-lime-600 ${sizing} ${full ? 'w-full' : ''}`} data-id="element-13" data-mp="198yxrgqr6p0e">
      <span data-id="element-14" data-mp="3jy8jhtugw4eg">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-smooth group-hover:translate-x-1" aria-hidden="true" data-id="element-15" data-mp="3ow0bsoz0xsj6" />
    </a>;
}